// extracted by mini-css-extract-plugin
export var section = "index-module--section--X4egB";
export var buttons = "index-module--buttons--YBnrJ";
export var container = "index-module--container--l0RDd";
export var variantWhite = "index-module--variant-white--c8+ls";
export var variantGrey = "index-module--variant-grey--scf0t";
export var variantDark = "index-module--variant-dark--S12XH";
export var titleContainer = "index-module--titleContainer--yW5oN";